import * as turf from "@turf/turf";
import * as egm96 from "egm96-universal";
import Map from "@/utils/Map";
import Map_DynamicMissionEvents from "@/utils/map/Map_DynamicMissionEvents";
import Map_DynamicMissionMaterial from "@/utils/map/Map_DynamicMissionMaterial";
import directionalMean from "@turf/directional-mean";


export default class Map_DynamicMissionGeometry {

  viewer;
  datasource;
  events;
  material;
  visible;
  name;
  id;
  isKmz;
  options;
  controlspoints;
  controlspointsEntities;
  takeoffEntity;
  colection;
  max_distance_show;
  listPrimitiveMission;
  frustum;
  targetsol;
  selectedIndex;
  sauvcontolpoints;

  constructor(viewer, datasource) {
    this.viewer = viewer;
    this.datasource = datasource;
    this.events = new Map_DynamicMissionEvents(this);
    this.material = new Map_DynamicMissionMaterial(this.events);
    this.visible = true;
    this.isKmz = false;
    this.controlspointsEntities = [];
    this.controlspoints = [];
    this.options = {altitudeMode : "", globalHeight : 0};
    this.takeoff = {position: undefined, height: 0, entity : undefined, lineStart :undefined, lineEnd : undefined};
    this.max_distance_show = 5000;
    this.listPrimitiveMission = [];
    this.frustum = undefined;
    this.drone = { entity: undefined, position : undefined, heading : 90, pitch: 0, speed :0};
    this.ispickcam = false;
    this.selectedIndex = -1;
    this.sauvcontolpoints = undefined;
    this.init();

  }

  init() {

    this.viewer.scene.preRender.addEventListener(() => {
      this.events.preRender();
    });
    this.initFrustum();
  }

  initFrustum() {
    //TODO connaitre le fov de la camera du drone.
    //zoom 4 par defaut
    this.frustum = {near :5, far: 250, fov :80 , heading :0, pitch:0,zoom:4, startheading:0, startPitch:0, startMouseX :0,startMouseY :0, prim : undefined, primout : undefined, isAction : false};
  }

  clear() {
    this.listPrimitiveMission.forEach((primitive) => {
      this.datasource._primitives.remove(primitive);
    });
    this.datasource.entities.removeAll();
    this.controlspoints = [];
    this.listPrimitiveMission = [];
    this.initFrustum();
  }

  clearRecord() {
    this.listPrimitiveMission.forEach((primitive) => {
      if(primitive.name && primitive.name != "" && primitive.name.indexOf("lineRecord") !== -1) {
        this.datasource._primitives.remove(primitive);
      }
    });
  }

  update(pickedInfos) {

    this.pickedInfos = pickedInfos;

    if(this.events.isActive() === false || this.isKmz === false) {
      return;
    }
    let index = -1;
    let indexControlPoint = -1;

    if(this.events.isFreeze() === false) {
      index = this.events.getPicked(false);
      indexControlPoint = this.events.getPicked(true);

      if(index !== -1 && indexControlPoint === -1) {
        this.viewer.canvas.style.cursor = "copy";
      }
      else if(indexControlPoint !== -1 && this.events.isSelected(index) === true) {
        this.events.isMove = true;
        this.viewer.canvas.style.cursor = "move";
        this.sauve(indexControlPoint);
        this.clearRecord();
      }
    }

    //Frustum
    if(this.events.isValidIndex(this.selectedIndex) &&
      ($root.global.flightedit.missionActionUpdate &&
        ($root.global.flightedit.missionActionUpdate.type === "yaw" ||
          $root.global.flightedit.missionActionUpdate.type === "pitch" ||
          $root.global.flightedit.missionActionUpdate.type === "zoom" ||
          $root.global.flightedit.missionActionUpdate.actuatorfunc === "orientedShoot"
        )
      ))
    {
      if(pickedInfos.element === "frustum" && pickedInfos.leftDown === true && this.ispickcam === false) {

        this.ispickcam = true;
        this.events.freezeCamera(true);
        this.frustum.startMouseX = pickedInfos.endPosition.x;
        this.frustum.startMouseY = pickedInfos.endPosition.y;
        this.frustum.startheading = this.frustum.heading;
        this.frustum.startPitch = this.frustum.pitch;
      }

      if (this.events.isFreeze() && this.ispickcam === true) {

        if($root.global.flightedit.missionActionUpdate.type === "zoom" || $root.global.flightedit.missionActionUpdate.actuatorfunc === "orientedShoot") {
          if(pickedInfos.wheel !== 0) {
            this.frustum.zoom += pickedInfos.wheel > 0 ? 1 : -1;
            this.frustum.zoom = Math.min(Math.max(this.frustum.zoom,1),54);
            pickedInfos.wheel = 0;
            //redessiner
            this.addFrustum();
            this.events.updateMissionAction("zoom",this.frustum.zoom * 23.9875);
          }
        }

        if($root.global.flightedit.missionActionUpdate.type === "yaw" || $root.global.flightedit.missionActionUpdate.actuatorfunc === "orientedShoot") {
          this.frustum.heading = this.frustum.startheading - ( this.frustum.startMouseX - pickedInfos.endPosition.x) / 4;
          this.frustum.heading > 180 ? this.frustum.heading -= 360 : this.frustum.heading < -180 ? this.frustum.heading += 360 :null;
          this.events.updateMissionAction("yaw",this.frustum.heading);
        }
        if($root.global.flightedit.missionActionUpdate.type === "pitch" || $root.global.flightedit.missionActionUpdate.actuatorfunc === "orientedShoot") {
          this.frustum.pitch = Math.min(Math.max(this.frustum.startPitch + ( this.frustum.startMouseY - pickedInfos.endPosition.y)/ 4,-90),45);
          this.events.updateMissionAction("pitch",this.frustum.pitch);
        }
        this.updateFrustum(this.getControlPoint(this.selectedIndex));

        if(pickedInfos.leftDown === false) {
          this.ispickcam = false;
          this.events.freezeCamera(false);
        }
      }
    }

    // Point au sol
    if(this.ispickcam === false)
    {
      if(pickedInfos.leftDown === true) {

        this.closeContextMenu();

        if(index !== -1 && this.viewer.canvas.style.cursor === "copy") {
            this.events.selectStep(index);
            this.events.pickedIndex = index;
        }
        else if(this.events.isMove === true && this.events.isFreeze() === false) {
          this.events.freezeCamera(true);
          this.hideFrustrum();
        }

        if(this.events.isFreeze() === true && this.events.pickedIndex !== -1) {
          this.setControlPoint(this.events.pickedIndex, this.pickedInfos.position);
          this.computeMidPoint();

        }
      }

      if (pickedInfos.leftDown === false && this.events.isFreeze()) {

        // console.log("fin deplacement");
        this.events.isMove = false;
        this.events.pickedIndex = -1;
        this.sauvcontolpoints = undefined;
        this.events.freezeCamera(false);
        this.computeHpr();
        this.computeMidPoint();
        this.events.selectStep(this.selectedIndex);
        this.viewer.canvas.style.cursor = "";
        this.events.updateTimeInfos();
      }
    }

    //clic droit
    if(pickedInfos.rightDown === true) {
      pickedInfos.rightDown = false;
      if(index !== -1 && this.viewer.canvas.style.cursor === "copy") {
        this.openContextMenuDelete(index);
      }
      else{
        this.openContextMenu();
      }
    }
  }

  cancel() {
    if(this.pickedInfos && this.pickedInfos.leftDown === true && this.events.isFreeze() === true) {
      this.events.freezeCamera(false);
      this.events.pickedIndex = -1;
      this.restore(this.selectedIndex);
    }
  }

  sauve(index) {
    if (this.events.isValidIndex(index)) {
      this.sauvcontolpoints = this.controlspoints[index].position.clone();
    }
  }
  restore(index) {
    if (this.events.isValidIndex(index) && Cesium.defined(this.sauvcontolpoints)) {
      this.controlspoints[index].position = this.sauvcontolpoints;
      this.sauvcontolpoints = undefined;

    }
  }


  setControlPoint(index, cartographic) {
    if (this.events.isValidIndex(index)) {
     // console.log("setControlPoint" + cartographic);
      const control = this.getControlPoint(index);
      cartographic.height = control.height;
      this.controlspoints[index].position = cartographic.clone();
    } else {
      // console.log("Erreur setControlPoint");
    }
    //this.viewer.scene.requestRender();
  }

  setName(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }

  getId() {
    return this.id;
  }

  setId(id) {
    this.id = id;
  }


  getVisibility() {
    return this.visible;
  }

  setVisibility(isVisble) {
    this.visible = isVisble;
  }

  setIsKmz(isKmz) {
    this.isKmz = isKmz;
  }

  getIsKmz() {
    return isKmz;
  }

  isFirst(index) {
    return index === 0;
  }

  isLast(index) {
    return index === this.controlspoints.length -1;
  }

  isFollow(index) {
    if(this.events.isValidIndex(index)) {
      return this.controlspoints[index].followroute;
    }
  }

  getHprHeading(index) {
    if(this.events.isValidIndex(index)) {
      this.computeHpr();
      return this.controlspoints[index].hpr.heading;
    }
  }


  setAsNoReturn(index, value) {
    if(this.events.isValidIndex(index)) {
      this.controlspoints[index].isNoReturn = value;
    }
  }

  getStepDistance(index) {
    if(this.events.isValidIndex(index)) {
      const text = this.controlspoints[index].midpointText;
      if(!isNaN(parseFloat(text))) {
        return parseFloat(text);
      }
    }
    return undefined;
  }

  async setAltitudeMode(altitudeMode) {
    if(this.options.altitudeMode !== altitudeMode) {
      this.options.altitudeMode = altitudeMode;
      await this.updateglobalHeight();
      this.addFrustum();
      this.events.setKeyInfos();
    }

  }

  getAltitudeMode() {
    return this.options.altitudeMode;
  }

  async setglobalHeight(globalHeight) {
    if(this.options.globalHeight !== globalHeight) {
      this.options.globalHeight = globalHeight;
      await this.updateglobalHeight();
      this.addFrustum();
      this.events.setKeyInfos();
    }
  }

  getglobalHeight() {
    return this.options.globalHeight;
  }

  async updateglobalHeight() {
    this.controlspoints.forEach(async (controlspoint) => {
      controlspoint.position.height = this.options.globalHeight;
      await this.convertHeightToGlobal(controlspoint.position, false);
    });

  }

  setglobalSpeed(globalSpeed) {
    this.controlspoints.forEach(async (controlspoint) => {
      controlspoint.speed = globalSpeed;
      this.drone.speed = globalSpeed;
      this.events.setKeyInfos();
    });
  }

  updateEgm96(cartographic) {
    const height = egm96.ellipsoidToEgm96(
      cartographic.latitude,
      cartographic.longitude,
      cartographic.height
    );

    return height;
  }

  updateWGS84(cartographic) {

    const height = egm96.egm96ToEllipsoid(
      cartographic.latitude,
      cartographic.longitude,
      cartographic.height
    );
    return height;
  }


  selectStep(index) {
    if(this.events.isValidIndex(index)) {
      this.drone.position = this.getControlPoint(index);
      this.drone.speed = this.controlspoints[index].speed;
      this.selectedIndex = index;
      this.events.setKeyInfos();

      this.updateFrustum(this.getControlPoint(index));
    }
  }

  setGeom(coords,speeds) {
    // console.log("Mission Geom");
    this.clear();

    coords.forEach((coord, i) => {

      const cartographic = new Cesium.Cartographic(
        coord[0],
        coord[1],
        coord[2]
      );

      if(i === 0) {
        this.initScene();
      }

      const point = this.getEntityPoint(i);
      const control = this.addControlPoint(i);

      let speed = 10;
      let heading = 0;

      if(i < speeds.length && !isNaN(parseFloat(speeds[i]))) {
        speed = parseFloat(speeds[i]);
      }

      this.controlspoints.push(this.createControlPoint(cartographic,point,control, undefined,heading, speed));
    });

    this.computeLines();
    this.computeHpr();
    this.computeMidPoint();
    this.events.updateTimeInfos();
    this.events.pickedIndex = -1;
  }

  createControlPoint(cartographic, point, control, line, heading, speed) {

    let entityPoint = undefined;
    let entityControl = undefined;
    let entityLine = undefined;

    if(point !== undefined) {
      entityPoint = this.datasource.entities.add(point);
    }
    if(control !== undefined) {
      entityControl = this.datasource.entities.add(control);
    }
    if(line !== undefined) {
      entityLine = this.datasource.entities.add(line);
    }

    const obj =  {position : cartographic, point : entityPoint , line : entityLine, control: entityControl, midpointPosition: undefined, midpointText:"", isNoReturn : false, hpr : new Cesium.HeadingPitchRoll(heading,0,0), followroute:true, speed : speed };
    return obj;
  }

  deleteLines() {
    this.controlspoints.forEach((controlspoint) => {
      if(controlspoint.line) {
        this.datasource.entities.remove(controlspoint.line);
        controlspoint.line = undefined;
      }
    });
  }

  computeLines() {

    this.deleteLines();
    this.controlspoints.forEach((controlspoint,i) => {

      if(i < this.controlspoints.length -1) {
        const line =this.getEntityLine(i);
        const entity = this.datasource.entities.add(line);
        controlspoint.line = entity;
      }
    });
  }

  computeHpr() {

    /*
    if(this.controlspoints.length > 0 && Cesium.defined(this.takeoff.position)) {
      const cartographicStart = this.takeoff.position;
      const cartographicEnd = this.controlspoints[0].position;
      const bearingAngle =  this.calcTurfAngle(cartographicStart, cartographicEnd);
      this.controlspoints[0].hpr.heading = bearingAngle;
    }*/

    for(let i = 0; i < this.controlspoints.length -1; i++) {
      if(this.controlspoints[i+1].followroute === true) {

        const cartographicStart = this.controlspoints[i].position;
        const cartographicEnd = this.controlspoints[i + 1].position;
        const bearingAngle =  this.calcTurfAngle(cartographicStart, cartographicEnd);
        this.controlspoints[i + 1].hpr.heading = bearingAngle;
      }
    }
  }

  calcTurfAngle(cartographicStart, cartographicEnd) {
    const coords= [[cartographicStart.longitude,cartographicStart.latitude],[cartographicEnd.longitude,cartographicEnd.latitude]];
    const lines = turf.lineString(coords);
    const directionalMeanLine = directionalMean(lines,{planar : false, segment : false});

    if(cartographicStart.longitude > cartographicEnd.longitude) {
      directionalMeanLine.properties.bearingAngle += 180;
    }
    return directionalMeanLine.properties.bearingAngle;

  }

  computeMidPoint() {
    for(let i = 0; i < this.controlspoints.length -1; i++) {
      const ptStart = this.controlspoints[i].position;
      const ptEnd = this.controlspoints[i + 1].position;
      const cartesianStart = Cesium.Cartesian3.fromDegrees(ptStart.longitude, ptStart.latitude, ptStart.height);
      const cartesianEnd = Cesium.Cartesian3.fromDegrees(ptEnd.longitude, ptEnd.latitude, ptEnd.height);
      let coord ={};

      Cesium.Cartesian3.lerp(cartesianStart,cartesianEnd, 0.5,coord);
      if(Cesium.defined(coord)) {

        const dist = Cesium.Cartesian3.distance(cartesianStart,cartesianEnd);
        this.controlspoints[i].midpointPosition = coord;
        this.controlspoints[i].midpointText = dist.toFixed(1);
      }

    }
  }

  initScene() {
    if(this.isKmz === true) {
      this.addFrustum();
      this.addDrone();
    }
  }

  addWaypoint(cartographic, index, heading, speed) {

    if(Cesium.defined(cartographic) === false) {
      if(Cesium.defined(this.drone.position)) {
        cartographic = this.drone.position.clone();
        heading = this.drone.heading;
        speed = this.drone.speed;
      }
      else{
        return;
      }
    }

    if(this.controlspoints.length === 0) {
      const point = this.getEntityPoint(this.controlspoints.length);
      const control = this.addControlPoint(this.controlspoints.length);
      this.controlspoints.push(this.createControlPoint(cartographic,point, control, undefined, heading, speed));
      this.initScene();
    }
    else{

      let newControlspoints = [];
      let isAdded = false;
      this.controlspoints.forEach((controlspoint, id) => {

        if(id >= index) {
          this.decalControlPoint(controlspoint ,id + 1);
        }
        if(id === index) {
          const point = this.getEntityPoint(index);
          const control = this.addControlPoint(index);
          newControlspoints.push(this.createControlPoint(cartographic,point,control, undefined, heading, speed));
          isAdded = true;
        }
        newControlspoints.push(controlspoint);
      });
      if(isAdded === false) {
        //last point
        const point = this.getEntityPoint(index);
        const control = this.addControlPoint(index);
        newControlspoints.push(this.createControlPoint(cartographic,point,control, undefined, heading, speed));
      }
      this.controlspoints =newControlspoints;
    }

    this.computeLines();
    this.computeHpr();
    this.computeMidPoint();
    this.events.updateTimeInfos();
    this.events.pickedIndex = -1;
  }

  updateWaypoint(index) {
    if(this.events.isValidIndex(index)) {

      if(Cesium.defined(this.drone.position)) {
        this.controlspoints[index].position = this.drone.position.clone();
        if(this.controlspoints[index].followroute === false) {
          this.controlspoints[index].hpr.heading = this.drone.heading;
        }
        this.controlspoints[index].speed = this.drone.speed;
      }
      this.updateFrustum(this.getControlPoint(index));
      this.events.updateTimeInfos();
      this.clearRecord();
    }
  }

  updateWaypointFollowRoute(index, isFollow) {
    this.controlspoints[index].followroute = isFollow;
    this.computeHpr();
  }

  async convertHeightToGlobal(cartographic, isWGS) {

    if(this.options.altitudeMode === "EGM96") {
      if(isWGS === false) {
        const heightWGS = this.updateWGS84(cartographic);
        cartographic.height = heightWGS;
      }
      else{
        const heightEGM96 = this.updateEgm96(cartographic);
        cartographic.height = heightEGM96;
      }
    }

    if(this.options.altitudeMode === "relativeToStartPoint") {
      if(Cesium.defined(this.takeoff.position)) {

        if(isWGS === false) {
          cartographic.height = cartographic.height + this.takeoff.position.height;
        }
        else{
          cartographic.height = cartographic.height - this.takeoff.position.height;
        }
      }
    }
    if(this.options.altitudeMode === "aboveGroundLevel") {
      const cartographicRadians = new Cesium.Cartographic(Cesium.Math.toRadians(cartographic.longitude), Cesium.Math.toRadians(cartographic.latitude), cartographic.height);
      //height =  await Map.getGroundHeight(cartographicRadians);
      const heightAGL = await Map.pickRayCast(cartographic);
      if(isWGS === false) {
        cartographic.height = cartographic.height + heightAGL;
      }
      else {
        cartographic.height = cartographic.height - heightAGL;
      }
    }
    return cartographic;
  }

  async updateDrone(cartographic, heading, speed) {

    if(Cesium.defined(cartographic)) {
      cartographic = await this.convertHeightToGlobal(cartographic, false);
      this.drone.position = cartographic;
    }
    if(!isNaN(parseFloat(heading))) {
      const yaw = parseFloat(heading) + 90;
      const diffheading= yaw - this.drone.heading;
      this.drone.heading = yaw;
      this.frustum.heading += diffheading;
      this.updateFrustum(this.getControlPoint(this.selectedIndex));
    }
    if(!isNaN(parseFloat(speed))) {
      this.drone.speed = parseFloat(speed);
    }
    this.events.setKeyInfos();

  }

  moveDrone(dirPos,dirAngle) {

    const cartesian = this.getDronePosition();
    this.drone.heading += dirAngle[0];
    this.frustum.heading += dirAngle[0];
    this.drone.pitch += dirAngle[1];

    this.drone.heading - 90 > 180 ? this.drone.heading -= 360 : this.drone.heading < -180 - 90 ? this.drone.heading += 360 : null;
    this.frustum.heading - 90 > 180 ? this.frustum.heading -= 360 : this.frustum.heading < -180 - 90 ? this.frustum.heading += 360 : null;

    const orientation = this.getDroneOrientation();
    const rotationMatrix = Cesium.Matrix3.fromQuaternion(orientation, new Cesium.Matrix3());
    const rotationScaled = Cesium.Matrix3.multiplyByVector(rotationMatrix, new Cesium.Cartesian3(dirPos[0], dirPos[1], dirPos[2]), new Cesium.Cartesian3());
    const roiPos = Cesium.Cartesian3.add(cartesian, rotationScaled, new Cesium.Cartesian3());
    const cartographic = Cesium.Cartographic.fromCartesian(roiPos);


    this.drone.position = new Cesium.Cartographic(
      Cesium.Math.toDegrees(cartographic.longitude),
      Cesium.Math.toDegrees(cartographic.latitude),
      cartographic.height
    );

    this.updateFrustum(this.getControlPoint(this.selectedIndex));
  }

  decalControlPoint(controlspoint, newid) {
    controlspoint.point.name  = "waypointMission" + (newid);
    controlspoint.point.position = new Cesium.CallbackProperty(() => {
      return this.getCartesianPoint(newid);
    }, false);
    controlspoint.point.polyline.positions = new Cesium.CallbackProperty(() => {
      return this.getCartesianLineGround(newid);
    }, false);
    controlspoint.point.billboard.image = this.material.getSvgStep(newid);

    controlspoint.control.position = new Cesium.CallbackProperty(() => {
      return this.getControlPointCartesian(newid);
    }, false);
    controlspoint.control.billboard.width = new Cesium.CallbackProperty(() => {
      return this.getontrolPointSize(newid);
    }, false);
    controlspoint.control.billboard.height = new Cesium.CallbackProperty(() => {
      return this.getontrolPointSize(newid);
    }, false);
  }

  removeWaypoint(index) {

    if(this.events.isValidIndex(index)) {

      if(this.controlspoints[index].control !== undefined) {
        this.datasource.entities.remove(this.controlspoints[index].control);
        this.controlspoints[index].control = undefined;
      }
      this.deleteLines();

      let newControlspoints = [];
      this.controlspoints.forEach((controlspoint, id) => {

        if(id > index) {
          this.decalControlPoint(controlspoint,id - 1);
        }
        if(id !== index) {
          newControlspoints.push(controlspoint);
        }
      });
      this.controlspoints =newControlspoints;

      this.computeLines();
      this.computeHpr();
      this.computeMidPoint();
      this.events.updateTimeInfos();
      this.events.pickedIndex = -1;

      if(this.controlspoints.length ===0) {
        this.hideFrustrum(this.stepFrustum);
      }
    }
  }

  getControlPoint(index) {
    if (index === undefined) {
      index = 0;
    }
    if (this.events.isValidIndex(index)) {
      return this.controlspoints[index].position;
    } else {
      return new Cesium.Cartographic(0, 0, 0);
    }
  }

  getCartesianPoint(index) {

    const cartographic = this.getControlPoint(index);
    let cartesian = this.cartesian3FromCartographicDegrees(cartographic); //Cesium.Cartesian3.fromDegrees(cartographic.longitude, cartographic.latitude, cartographic.height);
    return cartesian;

  }

  getCartesianLine(index) {
    let coordinates = [];
    const cartographicStart = this.getControlPoint(index);
    const cartographicEnd = this.getControlPoint(index +1);
    coordinates.push(cartographicStart.longitude);
    coordinates.push(cartographicStart.latitude);
    coordinates.push(cartographicStart.height);
    coordinates.push(cartographicEnd.longitude);
    coordinates.push(cartographicEnd.latitude);
    coordinates.push(cartographicEnd.height);
    let cartesians = Cesium.Cartesian3.fromDegreesArrayHeights(coordinates);
    return cartesians;
  }

  getCartesianLineGround(index) {
    let coordinates = [];
    const cartographicStart = this.getControlPoint(index);
    coordinates.push(cartographicStart.longitude);
    coordinates.push(cartographicStart.latitude);
    coordinates.push(cartographicStart.height);
    coordinates.push(cartographicStart.longitude);
    coordinates.push(cartographicStart.latitude);
    coordinates.push(0);
    let cartesians = Cesium.Cartesian3.fromDegreesArrayHeights(coordinates);
    return cartesians;
  }

  getCartesianMidline(index) {

    if (this.events.isValidIndex(index)) {
      if(Cesium.defined(this.controlspoints[index].midpointPosition)) {
        return this.controlspoints[index].midpointPosition;
      }
    }
    return new Cesium.Cartesian3();
  }

  getTextMidline(index) {

    if (this.events.isValidIndex(index)) {
      if(Cesium.defined(this.controlspoints[index].midpointPosition)) {
        return this.controlspoints[index].midpointText + " m";
      }
    }

    return "N.A";
  }

  getControlPointEntity(index) {
    if (this.events.isValidIndex(index)) {
      return this.controlspoints[index].point;
    }
  }

  getControlPointCartesian(index) {
    const cartographic = this.getControlPoint(index);
    let cartesian = this.cartesian3FromCartographicDegrees(cartographic);
    return cartesian;
  }

  getontrolPointSize(index) {
    if(this.events.isSelected(index)){
      return 8;
    }
    return 4;
  }

  isShowMidline(index) {
    const isSlected = this.selectedIndex === index ||  this.selectedIndex === index + 1;
    return this.isKmz && isSlected;
  }

  cartesian3FromCartographicDegrees(cartographic) {
    const cartesian = Cesium.Cartesian3.fromDegrees(
      cartographic.longitude,
      cartographic.latitude,
      cartographic.height
    );
    return cartesian;
  }

  getEntityLine(index) {

    let entity = {
      position : new Cesium.CallbackProperty(() => {
        return this.getCartesianMidline(index);
      }, false),
      polyline : {
        positions: new Cesium.CallbackProperty(() => {
          return this.getCartesianLine(index);
        }, false),
        width: 10,
        material: new Cesium.PolylineArrowMaterialProperty(
					Cesium.Color.WHITE.withAlpha(0.8)
				),
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show
        ),
      },
      label : {
        text : new Cesium.CallbackProperty(() => {
          return this.getTextMidline(index);
        }, false),
        backgroundColor : Cesium.Color.BLACK.withAlpha(0.8),
        fillColor : Cesium.Color.WHITE,
        scale :0.5,
        showBackground : true,
        backgroundPadding : new Cesium.Cartesian2(8,5),
        horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
        verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
        eyeOffset : new Cesium.Cartesian2(0,0,1),
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show
        ),
        show : new Cesium.CallbackProperty(() => {
          return this.isShowMidline(index);
        }, false),
      }
    }
    return entity;
  }



  getEntityPoint(index) {

      let entity = {
        position: new Cesium.CallbackProperty(() => {
          return this.getCartesianPoint(index);
        }, false),
        billboard: {
          image:  this.material.getSvgStep(index),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BASELINE,
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0.0,
            this.max_distance_show,
          ),
          pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
            200,
            2,
            this.max_distance_show,
            0.1
          ),
          scale:1,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          heightReference: Cesium.HeightReference.NONE,
        },
        polyline : {
          positions: new Cesium.CallbackProperty(() => {
            return this.getCartesianLineGround(index);
          }, false),
          width: 1,
          material: this.material.getLineMaterial(index),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0.0,
            this.max_distance_show
          ),
        },
        name : "waypointMission" + index,
      }
      return entity;
  }

  addControlPoint(index) {

    const entity = {
      position: new Cesium.CallbackProperty(() => {
        return this.getControlPointCartesian(index);
      }, false),
      billboard: {
        image:  this.material.getSvgCircle(index),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BASELINE,
        //alignedAxis: Cesium.Cartesian3.UNIT_Z,
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show ,
        ),
        scale:1,
        sizeInMeters: false, //bug affichage si mètres et distanceDisplayCondition
        width:new Cesium.CallbackProperty(() => {
          return this.getontrolPointSize(index);
        }, false),
        height:new Cesium.CallbackProperty(() => {
          return this.getontrolPointSize(index);
        }, false),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      },
      allowPicking: false,
      name : "waypointMission" + index + "_Control",
    };
    return entity;
  }

  AddLineRecord(listlinePosColor) {

    this.clearRecord();

    listlinePosColor.forEach((linePosColor, id) => {

      let primitive = new Cesium.Primitive({
        geometryInstances: new Cesium.GeometryInstance({
          geometry: new Cesium.PolylineGeometry({
            positions:  linePosColor.positions,
            width: 5.0,
            vertexFormat: Cesium.PolylineColorAppearance.VERTEX_FORMAT,
            colors:linePosColor.colors,
            colorsPerVertex: true,
          }),
            //id: "Polyline",
        }),
        appearance: new Cesium.PolylineColorAppearance({
          renderState: {
            depthTest: {
              enabled: false,
            },
          }
        }),
      });
      primitive.name = "lineRecord" + id;
      this.datasource._primitives.add(primitive);
      this.listPrimitiveMission.push(primitive);
    });

  }

  updateFrustum(cartographic) {

    const cartesian = this.cartesian3FromCartographicDegrees(cartographic);
		const hpr = new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(this.frustum.heading), Cesium.Math.toRadians(this.frustum.pitch - 90), 0);

    const fixedFrameTransform = Cesium.Transforms.localFrameToFixedFrameGenerator('north', 'west');
		const matrix = Cesium.Transforms.headingPitchRollToFixedFrame(cartesian, hpr , Cesium.Ellipsoid.WGS84, fixedFrameTransform);
		if(this.frustum.prim !== undefined && this.frustum.primout !== undefined) {
      this.frustum.prim.modelMatrix = matrix;
      this.frustum.primout.modelMatrix = matrix;
    }
  }

  hideFrustrum() {
    this.frustum.prim.modelMatrix = Cesium.Matrix4.IDENTITY;
    this.frustum.primout.modelMatrix = Cesium.Matrix4.IDENTITY;
  }

  setFrustumOrientationZoom(heading, pitch, focal) {


    if (this.events.isValidIndex(this.selectedIndex)) {
      if(heading !== undefined) {
        this.frustum.heading = heading;
      }
      if(pitch !== undefined) {
        this.frustum.pitch = pitch;
      }
      if(focal !== undefined && focal >= 0 ) {

        const zoom = focal / 23.9875;
        if(zoom != this.frustum.zoom) {
          this.frustum.zoom = zoom;
          this.addFrustum();
        }
      }
      this.updateFrustum(this.getControlPoint(this.selectedIndex));
    }
  }

  setFustrumAction(isAction, isInit) {

    if(isInit === undefined) {
      isInit = false;
    }
    if (this.events.isValidIndex(this.selectedIndex)) {
      if(this.frustum.isAction !== isAction || isInit === true) {

        this.frustum.isAction = isAction;
        this.addFrustum();
        this.updateFrustum(this.getControlPoint(this.selectedIndex));
      }
    }
  }

  getFrustumOrientation() {

    return Cesium.Quaternion.fromHeadingPitchRoll(
      new Cesium.HeadingPitchRoll(this.frustum.heading,this.frustum.pitch,0), new Cesium.Quaternion()
    );
  }

  getTakeOffPosition() {

    if(this.takeoff.position !== undefined) {
      let cartesian = Cesium.Cartesian3.fromDegrees(this.takeoff.position.longitude, this.takeoff.position.latitude, this.takeoff.position.height);
      return cartesian;
    }
    return this.getEmptyPoint();
  }

  setTakeOffPosition(cartographic) {
    if(Cesium.defined(cartographic)) {
      this.takeoff.position = cartographic;
    }
  }

  getTakeOffLineStart() {

    if(this.controlspoints.length >0 && Cesium.defined(this.takeoff.position)) {
      const cartographicStart = this.takeoff.position.clone();
      const cartographic = this.getControlPoint(0);
      let cartographicEnd = cartographicStart.clone();
      if(this.takeoff.height >=0) {
        cartographicEnd.height += this.takeoff.height;
      }
      else{
        cartographicEnd.height = cartographic.height ;
      }


      let cartesianStart = this.cartesian3FromCartographicDegrees(cartographicStart);
      let cartesianEnd = this.cartesian3FromCartographicDegrees(cartographicEnd);
      return [cartesianStart,cartesianEnd];
    }

    return this.getEmplytLine();
  }

  getEmplytLine() {
    const start = new Cesium.Cartesian3.fromDegrees(0, 0, 0);
    const end = new Cesium.Cartesian3.fromDegrees(0, 0, 1);

    return [start, end];
  }

  getEmptyPoint() {
    const start = new Cesium.Cartesian3.fromDegrees(0, 0, 0);
    return start;
  }

  getTakeOffLineEnd() {

    if(this.controlspoints.length >0 && Cesium.defined(this.takeoff.position)) {
      let cartographicStart = this.takeoff.position.clone();
      const cartographicEnd = this.getControlPoint(0);
      if(this.takeoff.height >=0) {
        cartographicStart.height  += this.takeoff.height;
      }
      else{
        cartographicStart.height = cartographicEnd.height;
      }

      let cartesianStart = this.cartesian3FromCartographicDegrees(cartographicStart);
      let cartesianEnd = this.cartesian3FromCartographicDegrees(cartographicEnd);
      return [cartesianStart,cartesianEnd];
    }

    return this.getEmplytLine();
  }

  setDronePosition(cartographic) {

    if(Cesium.defined(cartographic)) {
      this.drone.position =cartographic;
    }



   /* let cartesian = Cesium.Cartesian3.fromDegrees(this.drone.position.longitude, this.drone.position.latitude, this.drone.position.height);
    const hpr = new Cesium.HeadingPitchRoll(0,0,0);
    const fixedFrameTransform = Cesium.Transforms.localFrameToFixedFrameGenerator('north', 'west');
		const matrix = Cesium.Transforms.headingPitchRollToFixedFrame(cartesian, hpr , Cesium.Ellipsoid.WGS84, fixedFrameTransform);
    this.drone.entity.modelMatrix = matrix;*/

  }

  getDronePosition() {

    if(this.drone.position !== undefined) {
      let cartesian = Cesium.Cartesian3.fromDegrees(this.drone.position.longitude, this.drone.position.latitude, this.drone.position.height);
      return cartesian;
    }
    return this.getEmptyPoint();
  }

  getDroneLinePosition() {
    if(this.drone.position !== undefined) {
      let cartesian1 = Cesium.Cartesian3.fromDegrees(this.drone.position.longitude, this.drone.position.latitude, this.drone.position.height);
      let cartesian2 = Cesium.Cartesian3.fromDegrees(this.drone.position.longitude, this.drone.position.latitude, 0);
      return [cartesian1,cartesian2];
    }
    return this.getEmplytLine();
  }

  getDroneOrientation() {

    const hpr =  new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(this.drone.heading), Cesium.Math.toRadians(this.drone.pitch), 0);
    let orientation = Cesium.Transforms.headingPitchRollQuaternion(this.getDronePosition(), hpr);
    return orientation;

  }

  addDrone() {

    const entity = {

      position: new Cesium.CallbackProperty(() => {
        return this.getDronePosition();
      }, false),
      orientation :  new Cesium.CallbackProperty(() => {
        return this.getDroneOrientation();
      }, false),
      model: {
        uri: `${window.location.origin}/assets/3dModel/drone3d.glb`,
        scale: 10,
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0,
          this.max_distance_show,
        ),
        shadows: Cesium.ShadowMode.DISABLED,
      },
      polyline : {
        positions: new Cesium.CallbackProperty(() => {
          return this.getDroneLinePosition();
        }, false),
        width: 1,
        material: new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.WHITE.withAlpha(0.8),
        }),
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show
        ),
      },

    };
    this.drone.entity = this.datasource.entities.add(entity);
  }

  addFrustum() {

    if(this.frustum.prim !== undefined) {
      this.datasource._primitives.remove(this.frustum.prim);
      this.frustum.prim = undefined;
    }
    if(this.frustum.primout !== undefined) {
      this.datasource._primitives.remove(this.frustum.primout);
      this.frustum.primout = undefined;
    }

    let frustum = new Cesium.PerspectiveFrustum();
		frustum.fov = Cesium.Math.toRadians(this.frustum.fov / this.frustum.zoom);
		frustum.aspectRatio =  this.viewer.canvas.height/ this.viewer.canvas.width;
		frustum.near = this.frustum.near;
		frustum.far = this.frustum.far;

    let colorprim = new Cesium.Color(1.0, 1.0, 1.0, 0.15);
    let colorprimout = new Cesium.Color(0.0, 1.0, 0.0, 0.2);
    if(this.frustum.isAction === true) {
      colorprim = new Cesium.Color(1.0, 1.0, 1.0, 0.4);
      colorprimout = new Cesium.Color(0.0, 1.0, 0.0, 0.8);
    }

    let prim = new Cesium.Primitive({
      geometryInstances: new Cesium.GeometryInstance({
        geometry: new Cesium.FrustumGeometry({
          origin: new Cesium.Cartesian3(0,0,0),
          orientation: Cesium.Quaternion.fromHeadingPitchRoll(new Cesium.HeadingPitchRoll(0,0,0), new Cesium.Quaternion()),
          frustum: frustum,
          _drawNearPlane : true,
        }),
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(
            colorprim
          ),
        },
        id: 'frustum',
        pickPrimitive: this,
      }),
      appearance: new Cesium.PerInstanceColorAppearance({
        translucent: true,
        flat: true,
      }),
      asynchronous: false,
    });


    this.frustum.prim = this.datasource._primitives.add(prim);
    this.listPrimitiveMission.push(this.frustum.prim);
    let primout = new Cesium.Primitive({
      geometryInstances: new Cesium.GeometryInstance({
        geometry: new Cesium.FrustumOutlineGeometry({
          origin: new Cesium.Cartesian3(0,0,0),
          orientation: Cesium.Quaternion.fromHeadingPitchRoll(new Cesium.HeadingPitchRoll(0,0,0), new Cesium.Quaternion()),
          frustum: frustum,
          _drawNearPlane: true,
        }),
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(
            colorprimout
          ),
        },
        id: 'frustumline',
        pickPrimitive: this,
      }),
      appearance: new Cesium.PerInstanceColorAppearance({
        translucent: false,
        flat: true,
      }),
      asynchronous: false,
    });

    this.frustum.primout = this.datasource._primitives.add(primout);
    this.listPrimitiveMission.push(this.frustum.primout);
  }



  addTakeOff() {

    if(this.takeoff.entity !== undefined) {
      this.datasource.entities.remove(this.takeoff.entity);
      this.takeoff.entity = undefined;
    }

    const entityBillboard = {
      position: new Cesium.CallbackProperty(() => {
        return this.getTakeOffPosition();
      }, false),
      billboard: {
        image: "/assets/images/takeoff.svg",
        horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
        verticalOrigin : Cesium.VerticalOrigin.BASELINE,
        scale: 1,
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show
        ),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      },
    };
    const entityLineStart = {
      polyline : {
        positions: new Cesium.CallbackProperty(() => {
          return this.getTakeOffLineStart();
        }, false),
        width: 4,
        material: this.material.getPolylineMaterial(),
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show
        ),
      },
    };
    const entityLineEnd = {
      polyline : {
        positions: new Cesium.CallbackProperty(() => {
          return this.getTakeOffLineEnd();
        }, false),
        width: 10,
        material: this.material.getArrowLineMaterial(),
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show
        ),
      },
    };

    this.takeoff.entity = this.datasource.entities.add(entityBillboard);
    this.takeoff.lineStart = this.datasource.entities.add(entityLineStart);
    this.takeoff.lineEnd = this.datasource.entities.add(entityLineEnd);
  }

  updateTakeOff(flyToWaylineMode, takeOffSecurityHeight) {

    //safely -> Direct Ascent
    //pointToPoint -> Safe TakeOff
    if(flyToWaylineMode === "safely") {
      this.takeoff.height = -1;
    }
    else{
      this.takeoff.height = takeOffSecurityHeight;
    }
  }

  getMissionTime() {


    let length =0;
    let time = 0;
    for(let i=0; i< this.controlspoints.length -1; i++){

      const speed = this.controlspoints[i].speed;
      if(speed >0){
        const cartographicStart = this.controlspoints[i].position;
        const cartographicEnd = this.controlspoints[i +1].position;
        const cartesianStart = Cesium.Cartesian3.fromDegrees(cartographicStart.longitude, cartographicStart.latitude, cartographicStart.height);
        const cartesianEnd = Cesium.Cartesian3.fromDegrees(cartographicEnd.longitude, cartographicEnd.latitude, cartographicEnd.height);
        length +=  Cesium.Cartesian3.distance(cartesianStart, cartesianEnd);
        time += length/speed;
      }else{
        return null;
      }
    };

    //TODO ajouter les hover + autres actions ?
    return {time: time, length: length};
  }

  openContextMenu() {
    const info = {
      pos_x: this.pickedInfos.endPosition.x,
      pos_y: this.pickedInfos.endPosition.y,
    };

    this.events.activateContextMenu(info);
  }

  openContextMenuDelete(index) {
    const info = {
      pos_x: this.pickedInfos.endPosition.x,
      pos_y: this.pickedInfos.endPosition.y,
      isLast : this.isLast(index),
      isFirst : this.isFirst(index),
      IsNoreturn : this.events.isNoReturn(index),
      step: index +1,
      index:index,
    };
    this.events.activateContextMenuDelete(info);
  }

  closeContextMenu() {
    this.events.desactivateContexMenu();
  }

  async getWaypointsInfos() {
    let infos = [];
    this.controlspoints.forEach(async (controlspoint) => {

      let cartographic = controlspoint.position.clone();
      cartographic = await this.convertHeightToGlobal(cartographic, true);
      infos.push({coordinates :controlspoint.position.clone(), height: cartographic.height, heading : controlspoint.hpr.heading, speed : controlspoint.speed, isFollow : controlspoint.followroute });

    });
    return infos;
  }

  getGeom() {

    let coordinates = [];
    this.controlspoints.forEach(async (controlspoint) => {
      coordinates.push([controlspoint.position.longitude, controlspoint.position.latitude, controlspoint.position.height]);
    });
    return coordinates;
  }

  getCentroid() {

    if(this.controlspoints.length >0) {
      const dim = this.getBboxDim();
      let cartographics = [];

      if(dim.dimx > dim.dimy) {
        dim.dimy = Math.max(dim.dimx,0.002);
      }
      else{
        dim.dimx = Math.max(dim.dimy,0.002);
      }
      const cartographic1 = new Cesium.Cartographic(Cesium.Math.toRadians(dim.centerx - dim.dimx), Cesium.Math.toRadians(dim.centery - dim.dimy * 2.0), dim.centerz);
      const cartographic2 = new Cesium.Cartographic(Cesium.Math.toRadians(dim.centerx + dim.dimx), Cesium.Math.toRadians(dim.centery - dim.dimy * 2.0), dim.centerz);
      const cartographic3 = new Cesium.Cartographic(Cesium.Math.toRadians(dim.centerx - dim.dimx), Cesium.Math.toRadians(dim.centery), dim.centerz);
      const cartographic4 = new Cesium.Cartographic(Cesium.Math.toRadians(dim.centerx + dim.dimx), Cesium.Math.toRadians(dim.centery), dim.centerz);

      cartographics.push(cartographic1);
      cartographics.push(cartographic2);
      cartographics.push(cartographic3);
      cartographics.push(cartographic4);

      const rectangle = Cesium.Rectangle.fromCartographicArray(cartographics);
      return rectangle;
    }
  }

  getBboxDim() {
    let bbox = {xmin :180, xmax : -180, ymin:  90, ymax : -90, zmin : 1000, zmax :0};
    this.controlspoints.forEach((controlspoint) => {
      if(controlspoint.position.longitude < bbox.xmin) {
        bbox.xmin = controlspoint.position.longitude;
      }
      if(controlspoint.position.longitude > bbox.xmax) {
        bbox.xmax = controlspoint.position.longitude;
      }
      if(controlspoint.position.latitude < bbox.ymin) {
        bbox.ymin = controlspoint.position.latitude;
      }
      if(controlspoint.position.latitude > bbox.ymax) {
        bbox.ymax = controlspoint.position.latitude;
      }
      if(controlspoint.position.height < bbox.zmin) {
        bbox.zmin = controlspoint.position.height;
      }
      if(controlspoint.position.height > bbox.zmax) {
        bbox.zmax = controlspoint.position.height;
      }
    });
    const dimx = bbox.xmax - bbox.xmin;
    const dimy = bbox.ymax - bbox.ymin;
    const centerx = (bbox.xmax + bbox.xmin) /2;
    const centery = (bbox.ymax + bbox.ymin) /2;
    const centerz = (bbox.zmax + bbox.zmin) /2
    return {centerx: centerx, centery: centery, centerz: centerz, dimx:dimx,dimy:dimy};
  }


}
